export interface SettlementRequestToken {
  signature: string;
  key: string;
}

function createSettlementRequestKey(): string {
  return globalThis.crypto?.randomUUID?.() || `${Date.now()}-${Math.random()}`;
}

export function resolveSettlementRequestToken(
  current: SettlementRequestToken | null,
  signature: string,
): SettlementRequestToken {
  if (current?.signature === signature) return current;
  return { signature, key: createSettlementRequestKey() };
}
